export const MLFLOW_SYSTEM_TAGS_KEY_PREFIX: string = "mlflow.";
export const MLFLOW_SYSTEM_TAGS_RUN_NAME: string = "runName";
